import { Price } from '@app/entities/price';
import { Taxes } from '@user-history/entities/history-booking-detail';
import { Travelers } from '@booking/entities/booking-arrangement';
import { CancellationState } from '@shared/travel-assistance/entities/assistance-cancellation';
import { RequestSettingsByAssistanceReservation } from '@app/entities/request-settings';

export enum RouteType {
  ROUNDTRIP = 'RoundTrip',
  ONEWAY = 'OneWay',
  MULTIPLE_DESTINATION = 'MultipleDestination'
}

export interface AssistanceSearchPayload {
  AssistanceReservation?: AssistanceReservationInfo;
  Air_AssistanceReservation?: AirAssistanceReservation;
  RequestSettings: RequestSettingsByAssistanceReservation;
  CurrencyCode: string;
  SessionToken: string;
}

export interface AssistanceReservationInfo {
  OriginCityCode: string;
  DestinationCityCode: string;
  StartDate: string;
  EndDate: string;
  PassengerAges: number[];
  TravelItineraryId?: number;
  RouteType?: RouteType;
}

export interface AirAssistanceReservation {
  EndDate: string;
  TravelItineraryId: number;
}

export type AssistanceSearchResponse = Readonly<{
  SearchId: string;
  ResultsCount: number;
  ResultsAvailableUntil: string;
  Results: AssistanceSearchResult[];
  ValidDocuments: AssistanceValidDocuments[]
}>;

export interface AssistanceBookPayload {
  BookRequest: {
    OptionId: number;
    Passengers: Travelers[]
    TravelItineraryId?: number;
  };
  SearchId: string;
  SessionToken?: string;
}

export type AssistanceBookResponse = Readonly<{

}>;

export type AssistanceSearchResult = Readonly<{
  OptionId: number;
  TotalPrice: Price;
  Plans: AssistanceSearchPlan[];
  VendorLogo: string;
  VendorName: string;
}>;

export type AssistanceSearchPlan = Readonly<{
  Inclusions: AssistanceSearchInclusion[];
  PlanCode: string;
  PlanName: string;
  RelatedPassengerAges: number[];
  UnitPrice: number;
}>;

export type AssistanceSearchInclusion = Readonly<{
  Amount: number;
  Category: string;
  Code: string;
  CurrencyCode: string;
  Text: string;
}>;

export type AssistanceSearchInclusionDetail = Readonly<{
  Category: string;
  Inclusions: AssistanceSearchInclusion[];
}>;

export type AssistanceServiceDetail = Readonly<{
  SearchId: string;
  ResultsCount: number;
  ResultsAvailableUntil: string;
  Results: AssistanceSearchResult[];
}>;

export type AssistanceServicesDetail = Readonly<{
  ConfirmationNumber: string;
  Inclusions: AssistanceSearchInclusion[];
  Cost: {
    CurrencyCode: string;
    Amount: number;
    Commission: number;
    OverCommission: number;
    Surcharges: number;
    Markup: number;
    Taxes: Taxes[];
  };
  Price: Price;
  ProductCode: string;
  ProductDescription: string;
  TravelerIndex: number;
  VoucherURL: string;
}>;

export type AssistanceCancellationPayload = Readonly<{
  itineraryId: string;
  nssUserSessionToken?: string;
}>;

export type AssistanceCancellationResponse = Readonly<{
  itineraryId: number;
  status: CancellationState;
}>;

export type AssistanceConvertPdfPayload = Readonly<{
  url: string;
}>;

export type AssistanceConvertPdfResponse = Readonly<{
  file: string;
}>;

export type AssistanceValidDocuments = Readonly<{
  Id: number,
  Name: string,
  Regex: string,
  DocumentId: number
}>;
